import { DateTime } from "luxon";
import { escalationLabel } from "../escalation";
import type { ConversationFlagClear, Message } from "../types";
import { conversationFollowUpLabel } from "./followUp";

export const flagClearParts = (clear: ConversationFlagClear) => {
  const clearedAt = DateTime.fromISO(clear.cleared_at);
  return {
    who: clear.cleared_by_name || "A teammate",
    label:
      clear.kind === "escalation"
        ? escalationLabel(clear.reason)
        : conversationFollowUpLabel({ follow_up_reason: clear.reason }),
    when:
      DateTime.now().diff(clearedAt, "minutes").minutes < 1
        ? "Just now"
        : clearedAt.toRelative() || ""
  };
};

export const placeFlagClears = (
  messages: Pick<Message, "id" | "created_at">[],
  clears: ConversationFlagClear[] = []
): {
  before: ConversationFlagClear[];
  after: Map<string, ConversationFlagClear[]>;
} => {
  const before: ConversationFlagClear[] = [];
  const after = new Map<string, ConversationFlagClear[]>();
  const sorted = [...clears].sort(
    (a, b) => Date.parse(a.cleared_at) - Date.parse(b.cleared_at)
  );
  for (const clear of sorted) {
    const at = Date.parse(clear.cleared_at);
    const anchor = messages.reduce<(typeof messages)[number] | undefined>(
      (last, m) => (Date.parse(m.created_at) <= at ? m : last),
      undefined
    );
    if (!anchor) {
      before.push(clear);
      continue;
    }
    after.set(anchor.id, [...(after.get(anchor.id) ?? []), clear]);
  }
  return { before, after };
};
